/**
 * @abstract
 */
export default class AggregateRoot {

    /**
     * Get the id of the aggregate root
     *
     * @returns {string}
     *
     * @abstract
     */
    getId() { }

}